// Mobx
import LanguageStore from "../mobx/stores/LanguageStore";

// Helpers
import Helpers from '.';

const setLanguage = (languageCode: string) => {
    LanguageStore.updateLanguageData({
        ...LanguageStore.getLanguageData(),
        currentLanguage: languageCode
    })

    localStorage.setItem('language', languageCode);
}

const getSelectBoxLanguageItems = () => {
    const selectBoxItems: any[] = [];

    LanguageStore.languageData.languages.forEach((language) => {
        selectBoxItems.push({
            label: Helpers.translation(language),
            value: language
        })
    })

    return selectBoxItems;
}

const translation = (key: string) => {
    const languageData: any = LanguageStore.getLanguageData();

    if (Helpers.countProperties(languageData.contents) >= 1) {
        let currentLanguage = Helpers.getUserData().language !== '' ? Helpers.getUserData().language : languageData.currentLanguage;
        currentLanguage = currentLanguage !== null ? currentLanguage : languageData.currentLanguage;

        const langContent = languageData.contents[currentLanguage][Helpers.findIndexObjectInArray(languageData.contents[currentLanguage], 'key', key)];

        if (langContent !== undefined) {
            const type = langContent.editor !== null ? "editor" : "content";
            return langContent[type];
        }
    }

    return key;
}

const translationParams = (key: string, params?: any) => {
    let item = translation(key);

    if (params !== undefined) {
        if (item !== null) {
            for (const [key, value] of Object.entries(params)) {
                item = item.replace(`{${key}}`, value);
                item = item.replace(':' + key, value);
            }
        }
    }

    return item !== null ? item : key;
}

const exportHelpers = {
    getSelectBoxLanguageItems,
    setLanguage,
    translation,
    translationParams
};

export default exportHelpers;